import RecordTaxPaymentTask from 'modules/Tasks/SubmitActions/customComponents/RecordTaxPaymentTask';
import { QTEType } from 'modules/Tax/types';
import { SubmitActionTask } from 'modules/Tasks/types';

interface RecordQTEPaymentTaskProps {
    open: boolean;
    onClose: () => void;
    task: SubmitActionTask;
}

/**
 * `record_qte_payment` — the "I'll pay this one myself" child of the Q{quarter} tax payments card.
 * Personal quarterly estimates, so FEDERAL: that is what makes the modal derive
 * payment_type "quarterly", which the backend settles this card on.
 */
export default function RecordQTEPaymentTask({ open, onClose, task }: Readonly<RecordQTEPaymentTaskProps>) {
    return <RecordTaxPaymentTask open={open} onClose={onClose} task={task} taxType={QTEType.FEDERAL} />;
}
